import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

import Modal from '../Modal/Modal';
import setCreatePartTypeModalState from '../../actions/createPartTypeModal/createPartTypeModal';
import Text from '../Text/Text';
import Input from '../Input/Input';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import postOrderedPartType, { clearPostOrderedPartTypeData } from '../../thunks/general/postOrderedPartType';

const CreatePartTypeModal = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [typeText, setTypeText] = useState('');
  const [confirm, setSetConfirm] = useState(false);
  const {
    createPartTypeModalVisible,
    postOrderedPartsTypeData,
    postOrderedPartsTypeLoading,
  } = useSelector((state) => ({
    createPartTypeModalVisible: state?.createPartTypeModal.visible,
    postOrderedPartsTypeData: state?.postOrderedPartsType?.data,
    postOrderedPartsTypeLoading: state?.postOrderedPartsType?.loading,

  }), shallowEqual);

  const toggleVisible = () => dispatch(setCreatePartTypeModalState({ visible: !createPartTypeModalVisible }));

  const onConfirm = () => dispatch(postOrderedPartType({
    part_type: typeText.trim()
  }));

  useEffect(() => {
    if (postOrderedPartsTypeData) {
      setSetConfirm(false);
      toggleVisible();
      setTypeText('');
      enqueueSnackbar('Type create successfully', { variant: 'success' });
      dispatch(clearPostOrderedPartTypeData());
    }
    return () => dispatch(clearPostOrderedPartTypeData());
  }, [postOrderedPartsTypeData]);

  return (
    <>
      <Modal
        toggleVisible={toggleVisible}
        visible={createPartTypeModalVisible}
        onSave={() => setSetConfirm(true)}
        title="Create new type"
        canSave={typeText.length < 3 && !postOrderedPartsTypeLoading}
        hideCloseBtn
        saveText="Create"
      >
        <div>
          <div className="flex1">
            <Text text="Type:" styleContainer="mb-[6px]" textStyle="text-[13px]" required />
            <Input
              containerStyle="d-col"
              inputStyle="px-[13px] py-[8px] font-normal text-[13px]"
              type="typeText"
              name="typeText"
              value={typeText}
              placeholder="Type text"
              onChange={({ target: { value } }) => setTypeText(value)}
            />
          </div>
        </div>
      </Modal>
      <ConfirmModal
        visible={confirm}
        toggleVisible={() => setSetConfirm(false)}
        onConfirm={onConfirm}
        loading={postOrderedPartsTypeLoading}
      />
    </>
  );
};

CreatePartTypeModal.propTypes = {};

CreatePartTypeModal.defaultProps = {};

export default CreatePartTypeModal;
